import { Injectable } from '@angular/core';
import { LocalSaveService } from './local-save-service.service';

@Injectable({
  providedIn: 'root'
})
export class ClienteinfoService {
  private cliente = undefined;
  constructor(
    private localSave:LocalSaveService
  ) { 
    this.cliente = this.localSave.get('copycliente');
  }

  public setState(estado){
    this.localSave.set('estado',estado);
  }

  public getState(){
    return this.localSave.get('estado');
  }

  public setcliente(cliente,campana,agente){
    this.cliente = cliente;
    // alert('idcampana: '+this.cliente.idcampana)
    this.localSave.set('idcliente',this.cliente.idcliente);
    this.localSave.set('campanalista',this.cliente.idcampana ? this.cliente.idcampana : campana.idcampana);
    this.localSave.set('agente',agente);
    this.localSave.set('copycliente', cliente);
  }

  public removecliente(){
    this.cliente = undefined;
    this.localSave.delete('idcliente');
    this.localSave.delete('campanalista');
    this.localSave.delete('agente');
    this.localSave.delete('copycliente');
  }

  public getcampana(){
    if(this.cliente){
      return {nombrecampana:this.cliente.nombrecampana,script:this.cliente.script,urlscript:this.cliente.scripturl}
    }else{
      return {nombrecampana:'',script:'',urlscript:''};
    }
  }

  public getcliente(){
    if(this.cliente){
      return {local:true,cliente:this.cliente,idcampana:this.localSave.get('campanalista'),agente:this.localSave.get('agente')};
    }else{
      return {local:false, 
        cliente:{
          id:this.localSave.get('idcliente'),
          idcliente:this.localSave.get('idcliente'), 
          idcampana:this.localSave.get('campanalista')
        },idcampana:this.localSave.get('campanalista'),agente:this.localSave.get('agente')
        // ,cliente:this.localSave.get('idcliente')
      };
    }
  }

}
